import {errorModal, unlockExtraLevelModal, unlockLevelModal} from '../helpers/modal-builder'

import {
	addLoadingScreen,
	addModalWindow,
	addToast,
	decrementActiveRiddlePoints,
	EXTRA_SCREEN,
	PLAY_SCREEN,
	removeLoadingScreen,
	removeModalWindow,
	setActiveRiddle,
	SETTINGS_SCREEN,
	updateActiveLogoWithHint
} from './duck-screen';

import {
	fixUserDatabase,
	replaceUserStats,
	saveUserInfoAndSettings,
	saveUserRanking,
	updateHintCount
} from './duck-user';

import {saveAppConfig} from './duck-config';

import {
	CLOUD_FUNCTION_ROOT_COLLECTION,
	CLOUD_FUNCTION_ROOT_DOCUMENT,
	fsLevelCollection,
	fsUsersCollection,
	fsVersion,
	functions,
} from "../firestore";

import forge_sha256 from '../helpers/hash'
import { AES, enc as cryptoEncoding } from "crypto-js"
import {replaceRepeatingLetters, simplifyAnswer} from '../helpers/answer-manupulation'
import {playUnlockLevelAudio} from "../helpers/sounds";
import {getTranslation} from "../helpers/get-translation";
import {
	addReducerParametersToError,
	CRASH_CLOUD_FUNCTION_ERROR,
	CRASH_ERROR,
	isErrorFromCloudFunction,
	parseCloudFunctionErrorAndUnsetCode,
	sendError
} from "../middleware/middleware-error-handler";
import {goBack} from "./duck-router";
import {allHints, HINT_ANSWER5} from "../helpers/cloud-function/hint-types";
import {resetRanking, setActivePlayerStats} from "./duck-ranking";
import {ALMOST_GUESSED_ANSWER, CORRECT_ANSWER, WRONG_ANSWER} from "../components/game-screen/game-screen";


require("firebase/firestore");
require("firebase/functions");

export const SAVE_GAME_TYPE_LEVEL_PROPERTIES= "SAVE_GAME_TYPE_LEVEL_PROPERTIES";
export const SAVE_GAME_TYPE_USER_LEVELS= "SAVE_GAME_TYPE_USER_LEVELS";
export const SAVE_ALL_LEVEL_PROPERTIES= "SAVE_ALL_LEVEL_PROPERTIES";
export const SAVE_ALL_USER_LEVELS = "SAVE_ALL_USER_LEVELS";
export const SAVE_ALL_USER_RIDDLES = "SAVE_ALL_USER_RIDDLES";
export const SET_CURRENT_GAME_TYPE = "SET_CURRENT_GAME_TYPE";
export const SAVE_RIDDLES_FOR_LEVEL = "SAVE_RIDDLES_FOR_LEVEL";
export const UPDATE_RIDDLE_IN_RIDDLE_LIST = "UPDATE_RIDDLE_IN_RIDDLE_LIST";
export const RESET_RIDDLES_LIST_AFTER_DATABASE_RESET = "RESET_RIDDLES_LIST_AFTER_DATABASE_RESET";
export const ADD_POINTS_TO_LEVEL = "ADD_POINTS_TO_LEVEL";
export const DOWNLOADED_ALL_LEVEL_PROPERTIES = "DOWNLOADED_ALL_LEVEL_PROPERTIES";
export const DOWNLOADED_ALL_UNLOCKED_LEVELS = "DOWNLOADED_ALL_UNLOCKED_LEVELS";
export const RESET_STATE_AFTER_DATABASE_RESET = "RESET_STATE_AFTER_DATABASE_RESET";
export const TOGGLE_ANSWER_CHECK = "TOGGLE_ANSWER_CHECK";
export const INCREMENT_COLLECTED_RIDDLES = "INCREMENT_COLLECTED_RIDDLES";
export const SAVE_UNLOCKED_RIDDLES = "SAVE_UNLOCKED_RIDDLES";
export const SET_IS_LEVEL_UNLOCKING = "SET_IS_LEVEL_UNLOCKING";
export const SET_CURRENT_LEVEL = "SET_CURRENT_LEVEL";
export const SET_UNLOCK_LIMITS_FOR_EXTRA_LEVELS = "SET_UNLOCK_LIMITS_FOR_EXTRA_LEVELS";
export const SET_CURRENT_EXTRA_LEVEL = "SET_CURRENT_EXTRA_LEVEL";
export const DECREMENT_RIDDLE_POINTS_IN_LIST = "DECREMENT_RIDDLE_POINTS_IN_LIST";
export const SET_IS_DATABASE_RESETTING = "SET_IS_DATABASE_RESETTING";
export const RESET_GAME_AFTER_LOGOUT = "RESET_GAME_AFTER_LOGOUT";
export const SET_IS_DOWNLOADING_RIDDLES = "SET_IS_DOWNLOADING_RIDDLES";
export const RESET_USER_STATE_AFTER_LOGIN = "RESET_USER_STATE_AFTER_LOGIN";
export const UPDATE_HINT_CLUE_VALUE = "UPDATE_HINT_CLUE_VALUE";
export const INITIALIZE_STATS_IN_UNLOCKED_LEVEL = "INITIALIZE_STATS_IN_UNLOCKED_LEVEL";

/* Wszystkie asynchroniczne action creators Firestore */

/**
 * Wywoływane w play-screen po kliknięciu na poziom
 * odpowiada zo pobranie wszystkich riddle znajdujących się w klikniętym poziomie
 *
 * @param riddleRange - zakres riddle (logosFrom-logosTo)
 */
export function getRiddlesFromRange(riddleRange){
	return (dispatch, getState) => {
		const state = getState();
		const gameType = state.gameReducer.gameType;
		if(state.gameReducer.userRiddles[gameType]
			&& state.gameReducer.userRiddles[gameType][riddleRange]
			&& state.gameReducer.userRiddles[gameType][riddleRange].length > 0){
			console.log('lista lóg już w store');
		} else {
			//"1-3" -> 1, 3
			const [logosFrom, logosTo] = riddleRange.split('-').map(l => parseInt(l));

			if(isNaN(logosFrom) || isNaN(logosTo)){
				const error = Error(`Riddle range nie jest poprawny`);
				let inputParams = {
					gameType,
					riddleRange
				};
				dispatch(sendError(error, CRASH_ERROR, "error_riddle_range_incorrect", JSON.stringify(inputParams)))
				return
			}

			dispatch(setIsDownloadingRiddles(true));

			fsUsersCollection.doc(state.userReducer.uid)
				.collection('userRiddles')
				.where('gameType', '==', gameType)
				.where('lp', '>=', logosFrom)
				.where('lp', '<=', logosTo)
				.orderBy('lp')
				.get()
				.then(querySnapshot => {
					const riddlesList = querySnapshot.docs.map(doc => {
						return doc.data()
					});
					dispatch(saveRiddlesForLevel(riddlesList, riddleRange, gameType));
				})
				.catch (error => {
					console.log(error);
					debugger;
					// throw new Error("Nie udało się sciągnąć listy logotypów") //TODO
					let inputParams = {
						gameType,
						riddleRange
					};
					dispatch(sendError(error, CRASH_ERROR, 'error_logo_download_error', JSON.stringify(inputParams)));
				})
				.then(() => {
					dispatch(setIsDownloadingRiddles(false))
				})

		}
	}
}

/**
 * Wywoływany przy inicjacji aplikacji w store/index.js
 * Po resecie bazy danych również classic zaciągany //TODO czy potrzebne
 * Używane tylko do classic, dla innych gameType fetchAllLevelsProperties
 *
 * Ściąga pola z dokumentu levels (color, logosFrom....)
 *
 * @param gameType
 */
export function fetchGameTypeLevelsProperties(gameType = 'classic'){
	// const stateLevelList = store.getState().gameReducer.levelList[gameType];
	return (dispatch, getState) => {
		const state = getState();

		if(state.gameReducer.levelList[gameType]
			&& state.gameReducer.levelList[gameType].length > 0
			&& state.gameReducer.levelList[gameType][0].color){
			console.log('properties istnieje w store');
		} else {
			dispatch(addLoadingScreen('loading_levels', [SETTINGS_SCREEN, PLAY_SCREEN, EXTRA_SCREEN]));
			fsLevelCollection
				.where('gameType', '==', gameType)
				.orderBy('levelOrder')
				.get()
				.then(querySnapshot => {
					const levelList = querySnapshot.docs.map((doc) => {
						return doc.data()
					});
					dispatch(saveGameTypeLevelProperties(levelList, gameType));
				})
				.catch(error => {
					console.log(error);
					debugger;
					// throw new Error('properties nie dziala')

					dispatch(sendError(error, CRASH_ERROR, 'error_game_type_properties_download', JSON.stringify({gameType})));
				})
				.then(() => {
					dispatch(removeLoadingScreen('loading_levels'));
				})
		}
	}
}

/**
 * Wywoływana:
 * Ekran statystyk - stats-screen
 * Main screen - po kliknieciu na extra levels //TODO przeniesc do extra-level-screen
 *
 * Ściaga pola wszystkich dokumentów levels (color, logosFrom)
 *
 */
export function fetchAllLevelsProperties(){
	return dispatch => {
		dispatch(addLoadingScreen('loading_levels', [SETTINGS_SCREEN, PLAY_SCREEN, EXTRA_SCREEN]));
		fsLevelCollection
			.orderBy('levelOrder')
			.get()
			.then(querySnapshot => {
				const levelList = querySnapshot.docs.map(doc => {
					return doc.data();
				});

				const levelObject = transformLevelListToLevelGameTypeObject(levelList);
				dispatch(saveAllLevelProperties(levelObject));
			})
			.catch(error => {
				console.log(error);
				debugger;

				dispatch(goBack());
				// throw new Error('properties all nie dziala')
				dispatch(sendError(error, CRASH_ERROR, 'error_properties'));
			})
			.then(() => {
				dispatch(removeLoadingScreen('loading_levels'));
			})
	}
}


/**
 * Wywoływana:
 * duck-user -> initializeUserState()
 * duck-game -> resetUserDatabase()
 *
 * Pobiera wszystkie poziomy z konretnego typu gry.
 * Jeśli zwrócona lista jest pusta, oraz gameType to classic, to jeszcze
 * sprawdzamy czy w localStorage jest uid, jeśli nie ma to odpalana jest funkcja naprawiająca
 *
 */
export function fetchGameTypeUserLevels(gameType = 'classic'){
	return (dispatch, getState) => {
		const state = getState();
		if(state.gameReducer.levelList[gameType]
			&& state.gameReducer.levelList[gameType].length > 0
			&& state.gameReducer.levelList[gameType][0].collectedPoints){
			console.log('properties istnieje w store');
		} else {
			dispatch(addLoadingScreen('loading_levels', [SETTINGS_SCREEN, PLAY_SCREEN, EXTRA_SCREEN]));
			return fsVersion.collection(`users/${state.userReducer.uid}/userLevels`)
				.where('gameType', '==', gameType)
				.orderBy('levelOrder')
				.get()
				.then(querySnapshot => {
					const userLevelsList = querySnapshot.docs.map(doc => {
						return doc.data()
					});

					if(gameType === 'classic' && userLevelsList.length === 0){
						const oldUid = localStorage.getItem('oldUid');
						if(!oldUid){
							dispatch(fixUserDatabase())
						}
					} else {
						dispatch(saveGameTypeUserLevel(userLevelsList, gameType));
					}
				})
				.catch(error => {
					console.log(error);
					debugger;
					// throw new Error('nie moglo sciagnac pojedynczego userLevels')
					const inputParams = {
						gameType,
						uid: state.userReducer.uid
					};
					dispatch(sendError(error, CRASH_ERROR, 'error_single_user_levels_download', JSON.stringify(inputParams)));
				})
				.then(() => {
					dispatch(removeLoadingScreen('loading_levels'));
				})
		}
	}
}


/**
 * Wywoływana:
 * extra-levels-screen
 * stats-screen
 * W obu przypadkach tylko odpalana jeśli
 * allUserLevelsDownloaded === false (Jeszcze nie wchodziliśmy na ekran extra poziomów lub statystyk)
 *
 * Śćiąga wszystkie poziomy użytkownika
 *
 */
export function fetchAllUserLevels(){
	return (dispatch, getState) => {
		const state = getState();
		dispatch(addLoadingScreen('loading_levels', [SETTINGS_SCREEN, PLAY_SCREEN, EXTRA_SCREEN]));
		return fsVersion.collection(`users/${state.userReducer.uid}/userLevels`)
			.orderBy('levelOrder')
			.get()
			.then(querySnapshot => {
				const userLevels = querySnapshot.docs.map(doc => {
					return doc.data()
				});

				const levelObject = transformLevelListToLevelGameTypeObject(userLevels);

				dispatch(saveAllUserLevels(levelObject));
			})
			.catch(error => {
				console.log(error);
				debugger;

				dispatch(goBack());
				// throw new Error('nie moglo sciagnac wszystkich userLevels')
				const uid = state.userReducer.uid;
				dispatch(sendError(error, CRASH_ERROR, 'error_all_user_levels_download', JSON.stringify({uid})));
			})
			.then(() => {
				dispatch(removeLoadingScreen('loading_levels'));
			})
	}
}

/* Wszystkie asynchroniczne action creators Cloud Functions*/
/**
 * Wywoływana:
 * duck-user -> fsLoginUserAnonymously()
 * confirm-modal na ekranie ustawień
 *
 * Najpierw czyści bazę danych użytkownika
 * następnie inicjuje ją od nowa
 *
 */
export function resetUserDatabase(){
	return (dispatch, getState) => {
		dispatch(addLoadingScreen('loading_database_reset', [PLAY_SCREEN, EXTRA_SCREEN]));
		dispatch(setIsDatabaseResetting(true));

		dispatch(deleteUserDataCloudFunction())
			.then(itDeleted => {
				//Dopiero po uzyskaniu true z funckji kopiujemy startowe levele i riddle
				if(itDeleted){
					return dispatch(initializeUserCloudFunction(true))
				} else {
					dispatch(setIsDatabaseResetting(false));
					dispatch(removeLoadingScreen('loading_database_reset'));

					const state = getState();
					dispatch(sendError(new Error('Usuwanie zwróciło false podczas inicjalizacji bazy danych'), CRASH_CLOUD_FUNCTION_ERROR, 'error_could_initializing_user', JSON.stringify({uid: state.userReducer.uid})));
				}
			})
			.then(() => {
				dispatch(removeLoadingScreen('loading_database_reset'));
				dispatch(setIsDatabaseResetting(false));
			});

	};
}

function deleteUserDataCloudFunction(){
	return (dispatch, getState) => {
		const deleteUserData = functions.httpsCallable('deleteUserData');

		return deleteUserData({ CLOUD_FUNCTION_ROOT_COLLECTION, CLOUD_FUNCTION_ROOT_DOCUMENT })
			.then(result => {
				// console.log('wynik', result.data);
				return result.data
			})
			.catch(error => {
				console.log(error);
				debugger;
				const state = getState();

				if(isErrorFromCloudFunction(error)){
					const data = parseCloudFunctionErrorAndUnsetCode(error);

					dispatch(sendError(error, CRASH_CLOUD_FUNCTION_ERROR, 'error_delete_not_successful', data));
				} else {
					dispatch(sendError(error, CRASH_ERROR, 'error_delete_not_successful', JSON.stringify({uid: state.userReducer.uid})));
				}
				return false
			})
	}
}

/**
 * Funkcja wywoływany przy tworzeniu anonimowego użytkownika lub resecie bazy
 */
export function initializeUserCloudFunction(afterReset = false) {
	return (dispatch, getState) => {

		dispatch(addLoadingScreen('loading_database_initializing', [PLAY_SCREEN, EXTRA_SCREEN]));
		dispatch(setIsDatabaseResetting(true));

		const initializeUser = functions.httpsCallable('initializeUser');
		const state = getState();

		const rankingLanguage = (navigator.language || navigator.userLanguage || getTranslation("language")).substring(0, 2);
		const isAnonymous = state.userReducer.isAnonymous !== undefined && state.userReducer.isAnonymous !== null
			? state.userReducer.isAnonymous : true;

		return initializeUser({
			userLanguage: getTranslation("language"),
			rankingLanguage,
			isAnonymous,
			CLOUD_FUNCTION_ROOT_COLLECTION,
			CLOUD_FUNCTION_ROOT_DOCUMENT })
			.then(result => {
				dispatch(resetStateAfterDatabaseReset(result.data.riddleListByGameType));

				dispatch(saveUserInfoAndSettings(result.data.defaultUserFields));

				dispatch(saveAppConfig(result.data.defaultConfig));

				dispatch(saveUserRanking(result.data.defaultUserRankings));
				dispatch(setActivePlayerStats(result.data.defaultUserRankings));


				dispatch(fetchGameTypeLevelsProperties());
				dispatch(fetchGameTypeUserLevels());
			})
			.catch(error => {
				console.log(error);
				debugger;

				if(isErrorFromCloudFunction(error)){
					const data = parseCloudFunctionErrorAndUnsetCode(error);

					dispatch(sendError(error, CRASH_CLOUD_FUNCTION_ERROR, 'error_could_initializing_user', data));
				} else {
					dispatch(sendError(error, CRASH_ERROR, 'error_could_initializing_user', JSON.stringify({uid: state.userReducer.uid})));
				}
			})
			.then(() => {
				if(afterReset){
					dispatch(addToast('toast_data_base_reset_sucesfully'));
				}
				dispatch(removeLoadingScreen('loading_database_initializing'));
				dispatch(setIsDatabaseResetting(false));
			})
	}
}


/**
 * Wywoływana:
 * play-screen - jeśli pierwszy poziom extra levelu nie posiada collectedRiddles (czyli nie jest odblokowany)
 * duck-game -> checkRiddleAnswer() - jeśli przedział do odblokowania zostaje przekroczony
 * logos-screen-container - jeśli lista riddle jest pusta oraz aktualnie nie pobieramy riddli
 *
 * Kopiuje do użytkownika odblokowany poziom, zwrotke zapisuje w stanie
 *
 * @param gameType - z którego zostanie odblokowany poziom
 * @param unlockLimit - unlockLimit jaki był w properties poziomu
 * @param extra - flaga czy odblokowanie to extra poziom(np. Food level-1), a nie następny poziom
 */
export function unlockLevel(gameType, unlockLimit, extra=false) {
	let functionName = 'unlockLevel';
	if(extra){
		functionName = 'unlockExtraLevel';
	}

	return (dispatch, getState) => {
		dispatch(setIsLevelUnlocking(true));
		const unlockLevel = functions.httpsCallable(functionName);
		unlockLevel({
			language: getTranslation("language"),
			gameType,
			unlockLimit,
			CLOUD_FUNCTION_ROOT_COLLECTION,
			CLOUD_FUNCTION_ROOT_DOCUMENT })
			.then(result => {
				// debugger
				dispatch(saveUnlockedRiddles(gameType, result.data));
			})
			.catch(error => {
				console.log(error);
				debugger;
				const state = getState()

				if(isErrorFromCloudFunction(error)){
					const data = parseCloudFunctionErrorAndUnsetCode(error);

					dispatch(sendError(error, CRASH_CLOUD_FUNCTION_ERROR, 'error_level_unlock', data));
				} else {
					const inputParams = {
						gameType,
						unlockLimit,
						extra,
						uid: state.userReducer.uid
					};
					dispatch(sendError(error, CRASH_ERROR, 'error_level_unlock', JSON.stringify(inputParams)));
				}

			})
			.then(() => {
				// dispatch(removeLoadingScreen('loading_unlock_level'));
				dispatch(setIsLevelUnlocking(false));
			})
	}
}

/**
 * Wywołanie na game-screen po nacisnięciu guzika
 * Używane w celu szybkiego pokazania odblokowanej zagadki
 *
 * @param riddleKey
 * @param userAnswer
 */
export function quickRiddleAnswerCheck(riddleKey, userAnswer) {
	return (dispatch, getState) => {
		const state = getState();
		const cloudQuickRiddleAnswerCheck = functions.httpsCallable('quickRiddleAnswerCheck');
		cloudQuickRiddleAnswerCheck({ riddleKey, userAnswer, CLOUD_FUNCTION_ROOT_COLLECTION, CLOUD_FUNCTION_ROOT_DOCUMENT })
			.then(result => {
				return result.data
			})
			.then(riddle => {
				if(riddle && getState().screenReducer.activeLogo.lp === state.screenReducer.activeLogo.lp){
					const activeLogo = state.screenReducer.activeLogo;
					const activeLogoIndex = state.screenReducer.activeLogoIndex;

					const newActiveLogo = Object.assign({}, activeLogo, riddle);
					dispatch(setActiveRiddle(newActiveLogo, activeLogoIndex));
				}
			})
	}
}


/**
 * Wywołanie na game-screen po nacisnięciu guzika
 *
 * Na samym początku hashujemy odpowiedź użytkownika i poróbwnujemy z hashem w bazie
 * Później odpowiedź jeszcze sprawdzamy w cloud funkcji, tam ściagamy świeży hash z riddlesInLevels i porównujemy
 *
 * @param activeLogo - obiekt aktualnie wybrane riddle (duck-screen)
 * @param userAnswer - odpowiedź użytkownika
 * @param checkRiddleCallback - funkcja do które przesyłamy bool czy poprawna odpowiedź
 */
export function checkRiddleAnswer(activeLogo, userAnswer, checkRiddleCallback){
	return (dispatch, getState) => {
		dispatch(toggleAnswerCheck(true));

		const state = getState();

		const wasRiddleDecrypted = handleStateChangeAfterLocalGuess(state, dispatch);
		if(!wasRiddleDecrypted){
			quickRiddleAnswerCheck(activeLogo.riddleKey, userAnswer)
		}

		const { lp, gameType } = activeLogo;
		const cloudCheckRiddleAnswer = functions.httpsCallable('checkRiddleAnswer');
		// console.log('Sprawdzamy czy odpowiedź poprawna');
		cloudCheckRiddleAnswer({
			lp,
			gameType,
			userAnswer,
			CLOUD_FUNCTION_ROOT_COLLECTION,
			CLOUD_FUNCTION_ROOT_DOCUMENT
		}).then(result => {
			return result.data
		})
			.then(data => {
				const riddle = data.riddle;
				const userStats = data.stats;
				const isAlmostGuessed = data.isAlmostGuessed;
				const wasAlreadySolved = data.wasAlreadySolved;

				if (riddle) {
					updateRiddleAfterSolve(state, dispatch, riddle, userStats);

					const { activeLogoIndex, currentRiddleRange } = state.screenReducer;
					dispatch(updateRiddleInRiddlesList(riddle, gameType, currentRiddleRange, activeLogoIndex));

					if(!wasRiddleDecrypted && getState().screenReducer.activeLogo.lp === state.screenReducer.activeLogo.lp){
						dispatch(setActiveRiddle(riddle, state.screenReducer.activeLogoIndex));
					}

					dispatch(resetRanking());
					dispatch(toggleAnswerCheck(false));

					if(wasAlreadySolved){
						dispatch(addModalWindow(errorModal("error_riddle_already_solved", true)))
					} else {
						dispatch(incrementCollectedRiddles(gameType));
					}

				} else if(isAlmostGuessed){
					//TODO nic?
				} else {
					// const { currentRiddleRange, activeLogoIndex, activeLogo } = state.screenReducer;
					// dispatch(decrementActiveRiddlePoints());
					// dispatch(decrementRiddlePointsInList(currentRiddleRange, activeLogoIndex));
					if(userStats) {
						dispatch(replaceUserStats(userStats));
					}
				}
				// dispatch(toggleAnswerCheck(false));
			})
			.catch(error => {

				console.log(error);
				debugger;

				if(isErrorFromCloudFunction(error)){
					const data = parseCloudFunctionErrorAndUnsetCode(error);

					dispatch(sendError(error, CRASH_CLOUD_FUNCTION_ERROR, 'error_answer_check_logic', data));
				} else {
					const state = getState();
					const inputParams = {
						gameType,
						activeLogo,
						userAnswer,
						uid: state.userReducer.uid
					};

					dispatch(sendError(error, CRASH_ERROR, 'error_answer_check_logic', JSON.stringify(inputParams)));
				}
			})
	};

	function handleStateChangeAfterLocalGuess(state, dispatch) {

		const {isCorrect, isAlmostCorrect} = localAnswerCheck(activeLogo, userAnswer);

		if (isCorrect) {

			const riddleInfo = decryptRiddleInfo();

			updateStateAfterLocalGuess(state, dispatch, riddleInfo);

			checkRiddleCallback(CORRECT_ANSWER);

			return Object.entries(riddleInfo).length !== 0
		} else if (isAlmostCorrect) {
			dispatch(addToast('toast_almost_guessed'));
			const { activeLogoIndex, activeLogo, currentRiddleRange } = state.screenReducer;
			const { gameType } = state.gameReducer;

			const newActiveRiddle = Object.assign({}, activeLogo, {isAlmostGuessed: true});
			dispatch(setActiveRiddle(newActiveRiddle, activeLogoIndex));
			dispatch(updateRiddleInRiddlesList(newActiveRiddle, gameType, currentRiddleRange, activeLogoIndex));
			checkRiddleCallback(ALMOST_GUESSED_ANSWER);

			return false
		} else {
			const checkTimeout = Math.floor(Math.random() * Math.floor(100)) + 100;

			setTimeout(function () {
				checkRiddleCallback(WRONG_ANSWER);
			}, checkTimeout);

			return false
		}
	}

	function decryptRiddleInfo() {
		// encryptedAnswer: Array [ "U2FsdGVkX19UKnetpaU74R6BA3DoWXC4KPr9RqTLsG8=" ]
		// encryptedHintClue1: Array [ "U2FsdGVkX18uUMHz0pPa5nlpPIFGTNiwTzIiVb693jvNMMi2FdfByIIlj2HtItdJvfueuqfLmEswxmF9jbxzWZgIsMy4js6rLsVn+4etALLcmSg62FivxM1oDqmhotFUrhXnd+dDomizITQvxaj9sar2c2w3g0djxTD2Rviy8fA=" ]
		// encryptedHintClue2: Array [ "U2FsdGVkX1+rXMX+ZwhxPDmzrKqnKOrd9rzUBdN+6oKjyII6xn+TperZdETTZ0VApc0eJtchG+XWnd8JBvg7dhOPFscdRSzHV9ZU74FPodZ2j8SHjfoHirPOQ/Ea6D5N/L+rfrHNqBcwcLp/f0SIr1OijZVkfVufyR2Mvc9AldtOjIS/uCNpuyOkTcHL8gP1/Ys7E/RZKdEfn6XcWKNTKc2zV2NA+m1Ojv7imykTs/tCaIlhoDbieRAb14yB7e4Cp2piiYNNKIcqOQMf9e1rBBxWQGVBmBpQSDxkt3o+uXw=" ]
		// encryptedImgSolved: Array [ "U2FsdGVkX1+SQJqGSsTJxBjAMyzX9NQVsRGEeBHlGuI=" ]
		// encryptedWikipediaUrl: Array [ "U2FsdGVkX1+rXLUfbZmDnpohqqCq/vn7KLS3CfpyDEZkl0fDh54LNrPxiKTN+qSxwm0UxCnTXiC5uoY21D/lgw==" ]

		if(!hasEncryptionKeys()){
			return {}
		}

		const simplifiedUserAnswer = simplifyAnswer(userAnswer);
		const hashedUserAnswer = forge_sha256(simplifiedUserAnswer);
		const answerIndex = activeLogo.hashArray.findIndex(element => {
			return element === hashedUserAnswer
		});

		const decryptedRiddleInfo = {
			"answer": [ decryptValue(activeLogo["encryptedAnswer"][answerIndex], simplifiedUserAnswer) ],
			"hintClue1": decryptValue(activeLogo["encryptedHintClue1"][answerIndex], simplifiedUserAnswer),
			"hintClue2": decryptValue(activeLogo["encryptedHintClue2"][answerIndex], simplifiedUserAnswer),
			"imgSolved": decryptValue(activeLogo["encryptedImgSolved"][answerIndex], simplifiedUserAnswer),
			"wikipediaUrl": decryptValue(activeLogo["encryptedWikipediaUrl"][answerIndex], simplifiedUserAnswer)
		};

		const hasNull = Object.values(decryptedRiddleInfo).some(value => value === null);

		if(hasNull){
			return {}
		} else {
			return decryptedRiddleInfo
		}
	}

	function hasEncryptionKeys(){
		return "encryptedAnswer" in activeLogo &&
			"encryptedHintClue1" in activeLogo &&
			"encryptedHintClue2" in activeLogo &&
			"encryptedImgSolved" in activeLogo &&
			"encryptedWikipediaUrl" in activeLogo
	}

	function decryptValue(value, decryptionKey) {
		try{
			const decrypted = AES.decrypt(value, decryptionKey);
			const text = decrypted.toString(cryptoEncoding.Utf8);

			if(text){
				return text
			} else {
				return null
			}
		} catch (e) {
			return null
		}
	}
}

/**
 * Sprawdzanie odpowiedzi użytkownika po jego stronie przy użyciu zahashowanych odpowiedzi
 *
 * @param activeLogo
 * @param userAnswer
 * @returns { isCorrect: true } or { isCorrect: false, isAlmostCorrect: boolean }
 */

function localAnswerCheck(activeLogo, userAnswer) {
	const hashedUserAnswer = forge_sha256(simplifyAnswer(userAnswer));
	const isCorrect = activeLogo.hashArray.some(element => {
		return element === hashedUserAnswer
	});

	if(isCorrect){
		return { isCorrect }
	}

	const almostGuessedHashArray = activeLogo.hashAlmostGuessedArray || [];
	const isAlmostCorrect = almostGuessedHashArray.some(element => {
		return element === forge_sha256(replaceRepeatingLetters(simplifyAnswer(userAnswer)))
	});

	return { isCorrect, isAlmostCorrect }

}

/**
 * Aktualizuje stan po poprawnej odpowiedzi sprawdzonej lokalnie
 * @param state
 * @param dispatch
 * @param riddleInfo - (hintClue1, hintClue2, answer, imgSolved, wikiUrl) zwrócone po dektrypcji
 */
function updateStateAfterLocalGuess(state, dispatch, riddleInfo = {}) {

	showUnlockModalIfRequired(state, dispatch);

	const { activeLogoIndex, activeLogo, currentRiddleRange } = state.screenReducer;
	const { gameType } = state.gameReducer;

	const newActiveRiddle = Object.assign({},
		activeLogo,
		riddleInfo,
		{isSolved: true});
	console.log("localGuess setActiveRiddle", newActiveRiddle);
	dispatch(setActiveRiddle(newActiveRiddle, activeLogoIndex));

	dispatch(updateRiddleInRiddlesList(newActiveRiddle, gameType, currentRiddleRange, activeLogoIndex));

	dispatch(addPointsToLevel(currentRiddleRange, activeLogoIndex, newActiveRiddle.points));

	const userStats = state.userReducer.stats;
	const newUserStats = Object.assign(
		{},
		userStats,
		{ collectedPointsAll: userStats.collectedPointsAll + newActiveRiddle.points,
			collectedRiddlesAll: userStats.collectedRiddlesAll + 1 });

	dispatch(replaceUserStats(newUserStats));
}

/**
 * Funkcja która wysyłka request kupna hinta do cloud function
 * Używane w modalu po nacisnieciu zarowki na ekranie odgadywania zagadki
 *
 * @param hintType
 */
export function purchaseHint(hintType){
	return (dispatch, getState) => {
		const state = getState();
		const { activeLogo, activeLogoIndex, currentRiddleRange } = state.screenReducer;

		const hintPrice = state.configReducer.appConfig.strings.hintPrice;
		dispatch(updateHintCount(hintPrice[hintType], false));

		if(hintType === HINT_ANSWER5){
			dispatch(decrementActiveRiddlePoints(3));
			const newActiveRiddle = Object.assign({}, activeLogo, { isSolved: true, points: 0 });
			dispatch(setActiveRiddle(newActiveRiddle, activeLogoIndex));
			dispatch(removeModalWindow())
		} else {
			dispatch(decrementActiveRiddlePoints(1));
		}
		dispatch(decrementRiddlePointsInList(currentRiddleRange, activeLogoIndex));

		console.log(hintType);
		purchaseHintCloudFunction(hintType, state.gameReducer.gameType, activeLogo.lp)
			.then(hintValue => {
				const currentRiddleRange = state.screenReducer.currentRiddleRange;

				if(hintType === HINT_ANSWER5){
					const riddle = hintValue.riddle;
					const userStats = hintValue.stats;

					dispatch(updateRiddleInRiddlesList(riddle, state.gameReducer.gameType, currentRiddleRange, activeLogoIndex));

					dispatch(incrementCollectedRiddles(state.gameReducer.gameType))

					updateRiddleAfterSolve(state, dispatch, riddle, userStats);

					dispatch(addPointsToLevel(currentRiddleRange, activeLogoIndex, riddle.points));

					dispatch(setActiveRiddle(riddle, state.screenReducer.activeLogoIndex));

					dispatch(removeModalWindow());

					showUnlockModalIfRequired(state, dispatch);
					// unlockLevelOrShowModalIfRequirementsMet(state, dispatch, true);

				} else {
					const hintKey = allHints[hintType].firestoreKey;
					dispatch(updateHintClueValue(hintKey, hintValue, currentRiddleRange, activeLogoIndex));
					dispatch(updateActiveLogoWithHint(hintKey, hintValue, currentRiddleRange, activeLogoIndex))

				}
			})
			.catch(error => {
				console.log(error);
				debugger;

				if(isErrorFromCloudFunction(error)){
					const data = parseCloudFunctionErrorAndUnsetCode(error);

					dispatch(sendError(error, CRASH_CLOUD_FUNCTION_ERROR, 'error_purchase_hint', data));
				} else {
					const state = getState();
					const inputParams = {
						hintType,
						activeLogo,
						uid: state.userReducer.uid
					};

					dispatch(sendError(error, CRASH_ERROR, 'error_purchase_hint', JSON.stringify(inputParams)));
				}
			})
	}
}

function purchaseHintCloudFunction(hintType, gameType, lp){
	const purchaseHint = functions.httpsCallable('purchaseHint');

	return purchaseHint({
		hintType,
		gameType,
		lp,
		CLOUD_FUNCTION_ROOT_COLLECTION,
		CLOUD_FUNCTION_ROOT_DOCUMENT })
		.then(result => result.data)
}

/**
 * Funkcja aktualizuje stan po odgadnieciu riddle
 * wywoływana w checkRiddleAnswer i purchaseHint
 * @param state
 * @param dispatch
 * @param riddle
 * @param userStats
 */
function updateRiddleAfterSolve(state, dispatch, riddle, userStats) {
	if (userStats) {
		dispatch(replaceUserStats(userStats));
		dispatch(setActivePlayerStats(userStats));
	}

	addHintsIfCorrectModulo(state, dispatch);

	unlockLevelOnCorrectUnlockLimit(state, dispatch);
}

/**
 * Funkcja sprawdza czy te odgadniecie zagadki daje użytkownikowi dodatkowy hint
 * wywoływane w checkRiddleAnswer
 * @param state
 * @param dispatch
 */
function addHintsIfCorrectModulo(state, dispatch) {
	const hintsModulo = state.configReducer.appConfig.strings.hintsModulo;
	const collectedRiddlesAll = state.userReducer.stats.collectedRiddlesAll;

	if((collectedRiddlesAll + 1) % hintsModulo === 0){
		dispatch(addToast('toast_hints_increased'));
		dispatch(updateHintCount(1, true))
	}

}

/**
 * Pokazuje modal jeśli użytkownik odblokował poziom
 */
function showUnlockModalIfRequired(state, dispatch){
	const gameType = state.gameReducer.gameType;
	const collectedRiddles = state.gameReducer.collectedRiddlesForGameType[gameType];
	const unlockLimits = state.gameReducer.unlockLimitsForGameType[gameType] || [];
	const isSound = state.userReducer.settings.isSound;
	const levelList = state.gameReducer.levelList[gameType];

	checkLevelUnlockLimits(state, 1, onLevelUnlock, onExtraLevelUnlock);

	function onLevelUnlock(collectedRiddlesUsedForUnlock){
		const unlockedLevelIndex = unlockLimits.indexOf(collectedRiddlesUsedForUnlock);
		const unlockedLevel = levelList[unlockedLevelIndex];

		dispatch(initializeStatsInUnlockedLevel(gameType, unlockedLevelIndex));
		dispatch(addModalWindow(unlockLevelModal({
			levelName: unlockedLevelIndex + 1,
			unlockedLevel
		})));
		if (isSound) {
			playUnlockLevelAudio()
		}

		dispatch(updateHintCount(2, true))
	}


	function onExtraLevelUnlock(extraGameType){
		const levelIcon = state.configReducer.appConfig.gameTypesProperties[extraGameType].levelUnlockImage;
		dispatch(initializeStatsInUnlockedLevel(extraGameType, 0));
		dispatch(addModalWindow(unlockExtraLevelModal({levelName: extraGameType, levelIcon})));
		if (isSound) {
			playUnlockLevelAudio()
		}
	}
}

/**
 * Uruchamia funkcje odblokowywującą jeśli użytkownik odblokował poziom
 */
function unlockLevelOnCorrectUnlockLimit(state, dispatch){
	const gameType = state.gameReducer.gameType;

	checkLevelUnlockLimits(state, 2, onLevelUnlock, onExtraLevelUnlock);

	function onLevelUnlock(collectedRiddlesUsedForUnlock){
		dispatch(unlockLevel(gameType, collectedRiddlesUsedForUnlock));
	}

	function onExtraLevelUnlock(extraGameType, collectedRiddlesUsedForUnlock){
		dispatch(unlockLevel(extraGameType, collectedRiddlesUsedForUnlock, true));
	}
}

/**
 * Sprawdza czy użytkownik odblokował poziom
 */
function checkLevelUnlockLimits(state, collectedRiddleAddition, runOnLevelUnlock, runOnExtraLevelUnlock){
	const gameType = state.gameReducer.gameType;
	const collectedRiddles = state.gameReducer.collectedRiddlesForGameType[gameType];
	const unlockLimits = state.gameReducer.unlockLimitsForGameType[gameType] || [];
	const unlockLimitsForExtraLevels = state.gameReducer.unlockLimitsForExtraLevels;
	const collectedRiddlesForAllLevels = state.gameReducer.collectedRiddlesForAllLevels;

	isUnlockingLevel(runOnLevelUnlock);
	isUnlockingExtraLevel(runOnExtraLevelUnlock);

	function isUnlockingLevel(runOnLevelUnlock){
		const collectedRiddlesUsedForUnlock = collectedRiddles + collectedRiddleAddition;
		if (unlockLimits.indexOf(collectedRiddlesUsedForUnlock) > -1) {
			runOnLevelUnlock(collectedRiddlesUsedForUnlock);
		}
	}

	function isUnlockingExtraLevel(runOnExtraLevelUnlock){
		const collectedRiddlesUsedForUnlock = collectedRiddlesForAllLevels + collectedRiddleAddition;
		for (let extraGameType in unlockLimitsForExtraLevels) {
			if (unlockLimitsForExtraLevels.hasOwnProperty(extraGameType) &&
				unlockLimitsForExtraLevels[extraGameType] === collectedRiddlesUsedForUnlock) {

				runOnExtraLevelUnlock(extraGameType, collectedRiddlesUsedForUnlock);
			}
		}
	}
}

/* Wszystkie synchroniczne action creators */

/**
 * Wywoływana po poprawnym odgadnięciu riddle, aktualizuje dane riddla w stanie
 *
 * @param riddleData: obiekt z danymi od riddla(odpowiedz, obrazek, punkty etc...)
 * @param gameType
 * @param currentRiddleRange: "logosFrom-logosTo"
 * @param activeLogoIndex: index riddle w duck-game/userRiddles (userRiddles[gameType][riddleRange][TEN_INDEX])
 */
export function updateRiddleInRiddlesList(riddleData, gameType, currentRiddleRange, activeLogoIndex){
	// debugger;
	return {
		type: UPDATE_RIDDLE_IN_RIDDLE_LIST,
		payload: {
			riddleData,
			gameType,
			currentRiddleRange,
			activeLogoIndex
		}
	};
}

/**
 * Wywoływane po poprawnym odgadnięciu riddla
 *
 * Dodaje punkty do konkretnego riddle w duck-game/userRiddles
 *
 * @param currentRiddleRange: "logosFrom-logosTo"
 * @param riddleIndex: index riddle w duck-game/userRiddles (userRiddles[gameType][riddleRange][TEN_INDEX])
 * @param points: punkty zdobyte za riddle
 */
export function addPointsToLevel(currentRiddleRange, riddleIndex, points) {
	// debugger;
	return {
		type: ADD_POINTS_TO_LEVEL,
		payload: {
			currentRiddleRange,
			riddleIndex,
			points
		}
	};
}

/**
 * Wywoływane po poprawnym odgadnięciu riddle
 *
 * Inkrementuje collecedRiddle w globalnych pojemnikach
 * (collectedRiddlesForGameType[gameType] oraz collectedRiddlesForAllLevels)
 *
 * @param gameType
 */
export function incrementCollectedRiddles(gameType){
	return {
		type: INCREMENT_COLLECTED_RIDDLES,
		payload: {
			gameType
		}
	};
}

/**
 * Wywoływane:
 * main-screen - po kliknięciu play (gameType = 'classic')
 * extra-levels-screen - po wybraniu extra levela
 *
 * ustawia wybrany gameType w stanie aplikacji, używany w celu wydobycia listi riddli i poziomów w Componentach
 *
 * @param gameType
 */
export function setCurrentGameType(gameType) {
	return {
		type: SET_CURRENT_GAME_TYPE,
		payload: gameType
	};
}

/**
 * Wywoływane w duck-game -> checkRiddleAnswer()
 *
 * na początku odgadywania jest ustawiana na true,
 * po zwrotce z cloud function na false
 *
 * @param isChecking - boolean
 */
function toggleAnswerCheck(isChecking) {
	return {
		type: TOGGLE_ANSWER_CHECK,
		payload: {
			isChecking
		}
	};
}

/**
 * Wywoływana podczas odblokowywania poziomu
 *
 * Służy jako lock, zeby nie odpalić odblokowania dwa razy
 *
 * @param isUnlocking - boolean
 */
function setIsLevelUnlocking(isUnlocking) {
	return {
		type: SET_IS_LEVEL_UNLOCKING,
		payload: {
			isUnlocking
		}
	};
}

/**
 * Wywoływana:
 * play-screen - po naciśnięciu poziomu
 * unlock-level-modal - po naciśniećiu guzika
 *
 * Ustawia aktualnie wybrany poziom który jest używany do unlockLevel (unlockLimit).
 *
 * @param level - obiekt z polami dokumentu levels oraz userLevels (color, logosFrom, collectedPoints...)
 */
export function setCurrentLevel(level) {
	return {
		type: SET_CURRENT_LEVEL,
		payload: {
			level
		}
	};
}

/**
 * Wywoływane po wyborze poziomu w extra-level-screen
 *
 * Ustawia aktualnie wybrany extra poziom który jest używany do unlockLevel (unlockLimit).
 *
 * @param extraLevel - obiekt z polami dokumentu levels oraz userLevels (color, logosFrom, collectedPoints...)
 */
export function setCurrentExtraLevel(extraLevel){
	return {
		type: SET_CURRENT_EXTRA_LEVEL,
		payload: {
			extraLevel
		}
	}
}

/**
 * Wywoływane w duck-config -> fetchFsConfig()
 *
 * Zapisuje w stanie liste z unlockLimitami, są one używane do sprawdzenia czy użytkownik odblokował extraLevel,
 * po poprawnej odpowiedzi
 *
 * @param gameTypesProperties - config/appConfig/gameTypeProperties dokument określający kolory, unlockLimit...
 *
 */
export function setUnlockLimitsForExtraLevels(gameTypesProperties){
	return {
		type: SET_UNLOCK_LIMITS_FOR_EXTRA_LEVELS,
		payload: {
			gameTypesProperties
		}
	}
}


/**
 * Wywoływany po złej odpowiedźi
 *
 * Odejmuje punkty riddla w userRiddles
 *
 * @param currentRiddleRange - "logosFrom-logosTo"
 * @param activeLogoIndex - z duck-screen,
 */
export function decrementRiddlePointsInList(currentRiddleRange, activeLogoIndex){
	return {
		type: DECREMENT_RIDDLE_POINTS_IN_LIST,
		payload: {
			currentRiddleRange,
			activeLogoIndex
		}
	}
}

/**
 * Wywoływana podczas resetowania bazy danych
 *
 * @param state - boolean
 */
function setIsDatabaseResetting(state){
	return {
		type: SET_IS_DATABASE_RESETTING,
		payload: state
	}
}

/**
 * Wywołane w duck-user -> fsLogoutUser()
 *
 * Resetuje stan gameReducer do defaultowego
 *
 */
export function resetGameAfterLogout(){
	return {
		type: RESET_GAME_AFTER_LOGOUT
	}
}

/**
 * Wywoływany w duck-game -> fetchGameTypeLevelsProperties()
 *
 * levele są zapisywane do stanu i mergowane z userLevels
 *
 * @param levelList - array z obiektami odpowiadające dokumentowi w kolekcji levels
 * @param gameType
 */
export function saveGameTypeLevelProperties(levelList, gameType){
	return {
		type: SAVE_GAME_TYPE_LEVEL_PROPERTIES,
		payload: {
			levelList,
			gameType
		}
	}
}

/**
 * Wywoływane:
 * duck-game -> fetchGameTypeUserLevels()
 * duck-user -> fixUserDatabase()
 *
 * userLevels są zapisywane do stanu i mergowane z Levelami (kolekcji levels)
 *
 * @param userLevelsList - array z obiektami odpowiadające dokumentowi w kolekcji userLevels
 * @param gameType
 */
export function saveGameTypeUserLevel(userLevelsList, gameType){
	return {
		type: SAVE_GAME_TYPE_USER_LEVELS,
		payload: {
			userLevelsList,
			gameType
		}
	}
}

/**
 * Wywoływane:
 * duck-game -> fetchAllLevelsProperties()
 *
 * zapisuje wszystkie levele z kolekcji levels i merguje z userLevels
 *
 * @param levelObject - jest to obiekt który posiada klucze gameType,
 * a w środku array z obiektami levela odpowiadające dokumentowi level
 * {
 *  "classic:{
 *    color:...
 *  },
 *  "food":{
 *    color:...
 *   }
 * }
 *
 */
export function saveAllLevelProperties(levelObject){
	return {
		type: SAVE_ALL_LEVEL_PROPERTIES,
		payload: {
			levelObject
		}
	}
}

/**
 * duck-game -> fetchAllUserLevels()
 * duck-user -> mergeAndDeleteAnonymousUser()
 *
 * zapisuje wszystkie userLevels i merguje z levelami z kolecji levels
 *
 * @param levelObject - jest to obiekt który posiada klucze gameType,
 * a w środku array z obiektami userLevels
 *  {
 *  "classic:{
 *    collectedPoints:...
 *  },
 *  "food":{
 *    collectedPoints:...
 *   }
 * }
 */
export function saveAllUserLevels(levelObject){
	return {
		type: SAVE_ALL_USER_LEVELS,
		payload: {
			levelObject
		}
	}
}

/**
 * Wywoływany w duck-game -> getRiddlesFromRange()
 *
 * Zapisuje riddle do odpowiedniego gameType i riddleRange
 *
 * @param riddlesList - array skłądający się z obiektów dokumentu userRiddles
 * @param riddleRange - "logosFrom-logosTo"
 * @param gameType
 */
export function saveRiddlesForLevel(riddlesList, riddleRange, gameType){
	return {
		type: SAVE_RIDDLES_FOR_LEVEL,
		payload: {
			riddlesList,
			riddleRange,
			gameType
		}
	}
}

/**
 * Wywoływany w duck-user -> mergeAndDeleteAnonymousUser()
 *
 * Przewtarza obiekt w którym znajdują się wszystkie obiekty dokumentu userRiddles
 * na obiekt z podziałem na gameType oraz riddleRange
 *
 * @param riddleList
 * {
 * classic-0001:{
 *  lp: 1,
 *  ...
 * },
 * food-0001:{
 *   lp: 1,
 *   ...
 *  }
 * }
 */
export function saveAllUserRiddles(riddleList){
	return {
		type: SAVE_ALL_USER_RIDDLES,
		payload: {
			riddleList
		}
	}
}

/**
 * Wywoływane po resecie bazy danych
 *
 * @param riddlesGameType - obiekt podzielony na gameType z arrayem obiektów dokumentu userRiddles
 * {
 *  "classic":[
 *    {
 *      lp: 1,
 *      ...
 *    },
 *    ...
 *  ]
 * }
 */
export function resetStateAfterDatabaseReset(riddlesGameType){
	return {
		type: RESET_STATE_AFTER_DATABASE_RESET,
		payload: {
			riddlesGameType
		}
	}
}

/**
 * Wywoływane po odblokowaniu poziomu
 *
 * Zapisuje liste riddli do odpowiedniego gameType i riddleRange
 *
 * @param gameType
 * @param unlockedRiddlesList - array zawierający obiekty dokumentu userRiddles
 * [
 *  {
 *    lp: 1,
 *    ...
 *  },
 *  ...
 * ]
 */
export function saveUnlockedRiddles(gameType, unlockedRiddlesList){
	return {
		type: SAVE_UNLOCKED_RIDDLES,
		payload: {
			gameType,
			unlockedRiddlesList
		}
	};
}

/**
 * Wywoływane przy pobieraniu listy riddli (duck-game -> getRiddlesFromRange())
 *
 * Ustawia lock, który zapobiega odpalaniu funkcji odblokowywującej w logos-screen
 *
 * @param boolean
 */
function setIsDownloadingRiddles(boolean){
	return {
		type: SET_IS_DOWNLOADING_RIDDLES,
		payload: {
			isDownloadingRiddles: boolean
		}
	}
}

export function resetUserStateAfterLogin(){
	return {
		type: RESET_USER_STATE_AFTER_LOGIN,
	}
}


/**
 * Wywoływana na game-screen po pomyślnym zakupie hintu
 * @param hintKey - typ hinta z hint-types.js
 * @param hintValue - wartość zwrócona z cloud funkcji
 * @param currentRiddleRange - riddleRange do którego należy riddle
 * @param activeLogoIndex - index aktualnie aktywnego logo
 */
export function updateHintClueValue(hintKey, hintValue, currentRiddleRange, activeLogoIndex) {
	return {
		type: UPDATE_HINT_CLUE_VALUE,
		payload: {
			hintKey,
			hintValue,
			currentRiddleRange,
			activeLogoIndex
		}
	}
}

/**
 * Wywoływane przy pokazaniu modala odblokowania poziomu,
 * jest potrzebne żeby pokazać odblokowany level na liscie leveli
 * @param gameType
 * @param unlockedLevelIndex
 */
export function initializeStatsInUnlockedLevel(gameType, unlockedLevelIndex) {
	return {
		type: INITIALIZE_STATS_IN_UNLOCKED_LEVEL,
		payload: {
			gameType,
			unlockedLevelIndex,
		}
	}
}


/* Wewnętrzne funckje pomocnicze */
/**
 * Wywoływane w:
 * duck-user -> mergeAndDeleteAnonymousUser()
 * duck-game -> fetchAllUserLevels()
 *
 * Transformujemy zwrócony level do poprawnego formatu w stanie aplikacji
 * {
 * classic: [{}, {}],
 * foor: [{}]
 * }
 */
export function transformLevelListToLevelGameTypeObject(userLevels) {
	// debugger;
	const levelObject = {};

	for (let levelIndex in userLevels) {
		if (userLevels.hasOwnProperty(levelIndex)) {
			const gameType = userLevels[levelIndex].gameType;

			if (!levelObject[gameType]) levelObject[gameType] = [];

			levelObject[gameType].push(Object.assign({}, userLevels[levelIndex]));
		}
	}

	for (let gameType in levelObject) {
		levelObject[gameType].sort((a, b) => (a.levelOrder > b.levelOrder) ? 1 : -1)
	}
	return levelObject;
}

export function transformRiddleIdObjectToRiddleGameTypeObject(userRiddles) {
	let riddlesByGameType = {};
	for (let riddleIndex in userRiddles) {
		if (userRiddles.hasOwnProperty(riddleIndex)) {
			const gameType = userRiddles[riddleIndex].gameType;

			if (!riddlesByGameType[gameType]) riddlesByGameType[gameType] = [];
			riddlesByGameType[gameType].push(userRiddles[riddleIndex])
		}
	}
	return riddlesByGameType
}
/**
 * Wywoływane w akcji:
 * SAVE_ALL_USER_RIDDLES
 * RESET_STATE_AFTER_DATABASE_RESET
 *
 * Funkcja pomocnicza która transformuje zwykły array z riddlami, na obiekt
 * który jest podzielony na gameType oraz riddleRange.
 *
 * @param userRiddles - array z obiektami odpowiadające dokumentom w kolekcji userRiddles
 * [
 *  {
 *   lp: 1,
 *   ...
 *  },
 *  ...
 * ]
 *
 * @returns
 * {
 *  "classic": {
 *    "1-3": [
 *      {
 *        lp: 1,
 *        ...
 *      },
 *      ...
 *    ]
 *    ...
 *  },
 *  ...
 * }
 */
function transformRiddleListToUserRiddleObject(riddlesByGameType){
	// debugger;

	const riddleObject = {};
	for (let gameType in riddlesByGameType){
		// debugger;

		riddlesByGameType[gameType].sort((a, b) => (a.levelOrder > b.levelOrder) ? 1: -1);
		riddlesByGameType[gameType].sort((a, b) => (a.lp > b.lp) ? 1: -1);

		riddleObject[gameType] = {};

		//levelOrder pierwszego riddla w levelu
		let currentLevelOrder = null;
		//tablica w której przechowuje riddle aktualnego levela, po przejsciu na następna jet kopiowany do riddleObject
		let riddlesInThisLevel = [];
		for(let riddleIndex = 0; riddleIndex < riddlesByGameType[gameType].length; riddleIndex++){
			if(riddlesByGameType[gameType].hasOwnProperty(riddleIndex)){

				const riddle = Object.assign({}, riddlesByGameType[gameType][riddleIndex]);

				//Tylko na początku pętli wywoływany
				if(!currentLevelOrder){
					currentLevelOrder = riddle.levelOrder
				}

				//Jeżeli jesteśmy na ostatnim riddlu w liście to musimy go też dodać
				if(riddleIndex === riddlesByGameType[gameType].length-1){
					riddlesInThisLevel.push(riddle)
				}

				//Jeśli przeszliśmy na następny level
				if(riddle.levelOrder !== currentLevelOrder || riddleIndex === riddlesByGameType[gameType].length-1){
					const startingLp = riddlesInThisLevel[0].lp;
					const endingLp = riddlesInThisLevel[riddlesInThisLevel.length-1].lp;
					const riddleRange = `${startingLp}-${endingLp}`;

					//Do przedziału dodajemy zawarte w nim poziomy
					riddleObject[gameType][riddleRange] = [...riddlesInThisLevel];

					riddlesInThisLevel = [];

					currentLevelOrder = riddle.levelOrder
				}

				riddlesInThisLevel.push(riddle)
			}
		}
	}
	// debugger;
	return riddleObject
}


/**
 *
 * @param newGameTypeLevelList
 * @param currentGameTypeLevelList
 * newLevelList | currentLevelList =
 * {
 *  classic:[
 *   {color},{color},{color}
 *  ],
 *  food:[
 *   {color},{color},{color}
 *  ],
 * }
 *
 * Zwraca wszystkie gameType z obu list
 */
function mergeGameTypes(newGameTypeLevelList, currentGameTypeLevelList) {
	const mergedGameTypes = {};
	for (let gameType in newGameTypeLevelList) {
		if (newGameTypeLevelList.hasOwnProperty(gameType)) {
			if (!mergedGameTypes[gameType]) mergedGameTypes[gameType] = {}
		}
	}
	for (let gameType in currentGameTypeLevelList) {
		if (currentGameTypeLevelList.hasOwnProperty(gameType)) {
			if (!mergedGameTypes[gameType]) mergedGameTypes[gameType] = {}
		}
	}
	// console.log('mergedGameTypes', mergedGameTypes);
	return mergedGameTypes
}

/**
 *
 * @param newGameTypeLevelList
 * @param currentGameTypeLevelList
 * newGameTypeLevelList | currentGameTypeLevelList =
 * [
 *  {color}, {color}, {color}
 * ]
 *
 * Zawsze do większej listy łączy mniejszą
 */
function iterateOverBiggerOneAndMerge(newGameTypeLevelList, currentGameTypeLevelList){
	//Iterujemy zależnie która lista posiada więcej poziomów
	if(newGameTypeLevelList.length > currentGameTypeLevelList.length){
		return newGameTypeLevelList.map((level, index) => {
			// console.log(currentGameTypeLevelList[index] && currentGameTypeLevelList[index].levelOrder === level.levelOrder);
			// Jesli ten sam poziom w obu listach
			if(currentGameTypeLevelList[index]
				&& currentGameTypeLevelList[index].levelOrder === level.levelOrder) {
				return Object.assign({}, level, currentGameTypeLevelList[index])
			} else {
				return Object.assign({}, level)
			}
		})
	} else {
		return currentGameTypeLevelList.map((level, index) => {
			// console.log(newGameTypeLevelList[index] && newGameTypeLevelList[index].levelOrder === level.levelOrder);
			// Jesli ten sam poziom w obu listach
			if(newGameTypeLevelList[index]
				&& newGameTypeLevelList[index].levelOrder === level.levelOrder) {
				return Object.assign({}, level, newGameTypeLevelList[index])
			} else {
				return Object.assign({}, level)
			}
		})
	}
}

/**
 *
 * @param newLevelList: lista zwrócona z firestore
 * @param currentLevelList: lista z aktualnego stanu aplikacji
 * newLevelList | currentLevelList =
 * {
 *  classic:[
 *   {color},{color},{color}
 *  ],
 *  food:[
 *   {color},{color},{color}
 *  ],
 * }
 *
 * Łączy levelPropeeties i userLevels niezaleźnie od kolejności w której się sciągną
 *
 */
function mergePropertiesAndUnlockedLevels(newLevelList, currentLevelList){
	//Bierzemy wszystkie gameTypes z obu list
	const mergedGameTypes = mergeGameTypes(newLevelList, currentLevelList);

	for (let gameType in mergedGameTypes){
		if(mergedGameTypes.hasOwnProperty(gameType)) {
			if(currentLevelList.hasOwnProperty(gameType)){//Jeśli obecna lista posiada gameType

				if(newLevelList.hasOwnProperty(gameType)){//Jeśli nowa lista też posiada ten gameType
					mergedGameTypes[gameType] = iterateOverBiggerOneAndMerge(newLevelList[gameType], currentLevelList[gameType])
				} else { //Jeśli nowa lista nie posiada gameType zwracamy z obecnego
					mergedGameTypes[gameType] = currentLevelList[gameType]
				}

			} else if(newLevelList.hasOwnProperty(gameType)) {//Jesli obecna lista nie posiada gameType
				mergedGameTypes[gameType] = newLevelList[gameType];
			} else {
				console.log('currentLevelList', currentLevelList);
				console.log('newLevelList', newLevelList);
				throw Error("coś się pomieszało z mergem properties i userLevels")
			}
		}
	}

	return mergedGameTypes
}

/**
 * Iteruje po poziomach i zapisuje ich unlockLimit
 * @param levelList
 * {
 *  classic: [{}, {}],
 *  food: [{}]
 * }
 * @returns
 * {
 *  classic: [1, 2],
 *  food: [1]
 * }
 */
function createUnlockLimitsFromLevelList(levelList){
	// debugger;
	const newUnlockLimitList = {};
	// debugger

	Object.keys(levelList).forEach(gameType => {
		newUnlockLimitList[gameType] = levelList[gameType].map(level => {
			return level.unlockLimit
		})
	});

	// debugger

	return newUnlockLimitList
}


export const defaultState = {
	gameType: "classic",
	isCheckingAnswer: false,
	isUnlocking: false,
	isDownloadingRiddles: false,
	//Używane żeby wyłączyć ściąganie na guziku extra levels
	allLevelPropertiesDownloaded: false,
	allUserLevelsDownloaded: false,
	configLevelList:{
		"classic": [],
	},
	levelList: {
		"classic": [{aaa: "yyy"}],
	},
	// userRiddles - Obiekt w którym znajdują się wszystkie riddle, posegregowane według gameType oraz przedziału poziomu do którego należą
	userRiddles: {
		"classic": {
			'1-3': []
		},
	},
	currentLevel: {},
	currentExtraLevel: {},
	collectedRiddlesForGameType: {},
	collectedRiddlesForAllLevels: 0,
	unlockLimitsForGameType: {},
	unlockLimitsForExtraLevels: {},
	riddleCountForGameType: {},
	isDatabaseResetting: false,
};




export default function(state = defaultState, action) {
	try{
		switch (action.type) {
			case SAVE_GAME_TYPE_LEVEL_PROPERTIES: {
				const {gameType, levelList: newGameTypeLevelList} = action.payload;
				const {unlockLimitsForGameType} = state;
				const currentGameTypeLevelList = state.levelList[gameType];

				// console.log('newGameTypeLevelList', newGameTypeLevelList);
				let mergedLevelProperties;
				//Jesli w stanie coś już istnieje
				if (currentGameTypeLevelList.length > 0) {
					//iterujemy po zwrotce z firestore żeby zmergować z tym co już było
					mergedLevelProperties = newGameTypeLevelList.map((level, index) => {
						// console.log(currentGameTypeLevelList[index] && currentGameTypeLevelList[index].levelOrder === level.levelOrder);
						//Jesli mamy odpowiednik w odblokowanych poziomach
						if (currentGameTypeLevelList[index]
							//Jesli posiadaja ta sama kolejnosc
							&& currentGameTypeLevelList[index].levelOrder === level.levelOrder) {
							return Object.assign({}, level, currentGameTypeLevelList[index])
						} else {
							return level
						}
					});
				} else {
					mergedLevelProperties = newGameTypeLevelList
				}
				// console.log('mergedLevelList', mergedLevelProperties);
				// debugger

				const unlockLimits = mergedLevelProperties.map(level => level.unlockLimit);
				const newUnlockedLevelsForGameType = Object.assign({}, {...unlockLimitsForGameType}, {[gameType]: unlockLimits});


				//{ classic: [ {…}, {…}, {…} ] }
				const newLevelList = Object.assign({}, {...state.levelList}, {[action.payload.gameType]: mergedLevelProperties});
				const returnState = Object.assign({}, {...state},
					{levelList: newLevelList},
					{configLevelList: newLevelList},
					{unlockLimitsForGameType: newUnlockedLevelsForGameType}
				);

				return returnState
			}

			case SAVE_GAME_TYPE_USER_LEVELS: {
				const {gameType, userLevelsList} = action.payload;
				const {
					levelList,
					collectedRiddlesForGameType
				} = state;

				let mergedLevelProperties;
				let collectedRiddlesValue = 0;
				if (levelList[gameType].length > 0) {
					mergedLevelProperties = levelList[gameType].map((level, index) => {
						//Jesli mamy odpowiednik w odblokowanych poziomach
						// console.log('userLevelsList[index]', userLevelsList[index]);
						// console.log(userLevelsList[index] && userLevelsList[index].levelOrder === level.levelOrder);
						if (userLevelsList[index]
							//Jesli posiadaja ta sama kolejnosc
							&& userLevelsList[index].levelOrder === level.levelOrder) {
							collectedRiddlesValue += userLevelsList[index].collectedRiddles;
							// console.log('przechodzi');
							return Object.assign({}, level, userLevelsList[index])
						} else {
							return level
						}
					});
				} else {
					mergedLevelProperties = userLevelsList

					collectedRiddlesValue = userLevelsList.reduce((acc, level) => {
						return acc + level.collectedRiddles
					}, 0)
				}
				// console.log('mergedLevelProperties', mergedLevelProperties);
				//{ classic: liczba rozwiązanych riddli w classicu }
				const newCollectedRiddles = Object.assign({}, {...collectedRiddlesForGameType}, {[gameType]: collectedRiddlesValue});

				let collectedRiddlesForAllLevelsValue = 0;
				for (let gameType in newCollectedRiddles) {
					if (newCollectedRiddles.hasOwnProperty(gameType)) {
						collectedRiddlesForAllLevelsValue += newCollectedRiddles[gameType];
					}
				}

				//{ classic: [ {…}, {…}, {…} ] }
				const newLevelList = Object.assign({}, {...state.levelList}, {[action.payload.gameType]: mergedLevelProperties});

				//{ username: "1@gmail.com", uid: "nG3OaFpe2lbLykkhvlH5MU4JRPp2", collectedRiddlesForGameType: { newCollectedRiddles } }
				// const newUnlockedLevelsCollectedRiddles = {collectedRiddlesForGameType: newCollectedRiddles} );
				// console.log(newLevelList);
				const returnState = Object.assign({}, {...state},
					{levelList: newLevelList},
					{collectedRiddlesForGameType: newCollectedRiddles},
					{collectedRiddlesForAllLevels: collectedRiddlesForAllLevelsValue}
				);

				return returnState
			}

			/**
			 * Wywołane przy wejściu na ekran statystyk, i na ekran extra levels
			 */
			case SAVE_ALL_LEVEL_PROPERTIES: {

				const newLevelList = action.payload.levelObject;
				const currentLevelList = state.levelList;
				// debugger;

				//{ classic: [ {...}, {...}, {...} ], food: [ {...}, {...} ] }
				const mergedLevelList = mergePropertiesAndUnlockedLevels(newLevelList, currentLevelList);
				// debugger;

				const newUnlockLimitList = createUnlockLimitsFromLevelList(mergedLevelList);
				const returnState = Object.assign(
					{},
					{...state},
					{levelList: mergedLevelList},
					{unlockLimitsForGameType: newUnlockLimitList},
					{allLevelPropertiesDownloaded: true});
				// console.log('mergedLevelList', mergedLevelList);

				return returnState;
			}

			/**
			 * Akcja wywołana po wejściu na ekran extra levels, lub po merge
			 */
			case SAVE_ALL_USER_LEVELS: {
				const newLevelList = action.payload.levelObject;
				const currentLevelList = state.levelList;
				//{ classic: [ {...}, {...}, {...} ], food: [ {...}, {...} ] }
				const mergedLevelList = mergePropertiesAndUnlockedLevels(newLevelList, currentLevelList);
				console.log(mergedLevelList)

				const newCollectedRiddles = {};
				const riddleCountForGameType = {};
				// debugger
				for (let gameType in mergedLevelList) {
					if (mergedLevelList.hasOwnProperty(gameType)) {
						newCollectedRiddles[gameType] = 0;
						riddleCountForGameType[gameType] = 0;
						// console.log(mergedLevelList[gameType])
						for (let level in mergedLevelList[gameType]) {
							if (mergedLevelList[gameType].hasOwnProperty(level)) {
								// console.log(mergedLevelList[gameType][level])
								// console.log(mergedLevelList[gameType][level].collectedRiddles)
								newCollectedRiddles[gameType] += mergedLevelList[gameType][level].collectedRiddles || 0;

								const logosTo = mergedLevelList[gameType][level].logosTo;
								if (logosTo > riddleCountForGameType[gameType]) {
									riddleCountForGameType[gameType] = logosTo
								}
							}
						}
					}
				}


				console.log(riddleCountForGameType);

				let collectedRiddlesForAllLevelsValue = 0;
				for (let gameType in newCollectedRiddles) {
					if (newCollectedRiddles.hasOwnProperty(gameType)) {
						collectedRiddlesForAllLevelsValue += newCollectedRiddles[gameType];
					}
				}

				// collectedRiddlesForGameType
				// debugger;

				const returnState = Object.assign(
					{},
					{...state},
					{levelList: mergedLevelList},
					{collectedRiddlesForGameType: newCollectedRiddles},
					{collectedRiddlesForAllLevels: collectedRiddlesForAllLevelsValue},
					{riddleCountForGameType},
					{allUserLevelsDownloaded: true}
				);
				// console.log('mergedLevelList', mergedLevelList);

				// debugger;

				return returnState;

			}

			case SAVE_RIDDLES_FOR_LEVEL: {//TODO nie zapisuje arraya, tylko obiekt z kluczami "0"
				//{ 1-3: [ {…}, {…}, {…} ] }
				const currentRiddlesList = Object.assign({}, {...state.userRiddles[action.payload.gameType]}, {
						[action.payload.riddleRange]:
						action.payload.riddlesList
					}
				);

				//{ classic: currentRiddlesList } }
				const currentGameTypeRiddlesList = Object.assign({}, {...state.userRiddles}, {
					[action.payload.gameType]: currentRiddlesList
				});

				const currentState = Object.assign({}, {...state}, {
					userRiddles: currentGameTypeRiddlesList
				});
				return currentState;
			}

			/**
			 * Akcja wywoływana po merge, przesyłane są wszystkie riddle użytkownika
			 */
			case SAVE_ALL_USER_RIDDLES: {
				// debugger;
				const riddlesGameType = transformRiddleIdObjectToRiddleGameTypeObject(action.payload.riddleList);
				const riddleObject = transformRiddleListToUserRiddleObject(riddlesGameType);

				return Object.assign({}, {...state}, {userRiddles: riddleObject});

			}

			case RESET_STATE_AFTER_DATABASE_RESET:
				//Ustawiamy defaultowe wartości
				// debugger;

				const riddleObject = transformRiddleListToUserRiddleObject(action.payload.riddlesGameType);

				return Object.assign({},
					{...defaultState},
					{
						levelList: defaultState.configLevelList,
						configLevelList: state.configLevelList,
						userRiddles: riddleObject,
						isDatabaseResetting: state.isDatabaseResetting,
						unlockLimitsForExtraLevels: state.unlockLimitsForExtraLevels
					}
				);

			case UPDATE_RIDDLE_IN_RIDDLE_LIST: {
				// console.log(state.userRiddles[action.payload.gameType][action.payload.currentRiddleRange]);
				//riddle otrzymaliśmy po ogadnięciu łączymy z tym w stanie
				// debugger;
				const newRiddlesList = state.userRiddles[action.payload.gameType][action.payload.currentRiddleRange].map(
					(riddle, index) => {
						if(index === action.payload.activeLogoIndex){
							return Object.assign({}, riddle, action.payload.riddleData)
						} else {
							return Object.assign({}, riddle)
						}
					}
				);
				// debugger;

				const currentRiddlesList = Object.assign({}, {...state.userRiddles[action.payload.gameType]}, {
						[action.payload.currentRiddleRange]:
						newRiddlesList
					}
				);
				// debugger;
				const currentGameTypeRiddlesList = Object.assign({}, {...state.userRiddles}, {
					[action.payload.gameType]: currentRiddlesList
				});

				const currentState = Object.assign({}, {...state}, {
					userRiddles: currentGameTypeRiddlesList
				});
				return currentState;
			}

			case ADD_POINTS_TO_LEVEL: {
				const {
					riddleIndex,
					currentRiddleRange
				} = action.payload;

				const gameType = state.gameType;

				const currentRiddle = state.userRiddles[gameType][currentRiddleRange][riddleIndex];

				//sprawdzamy do którego poziomu należy riddle
				const levelIndex = state.levelList[gameType].findIndex((level) => {
					return level.levelOrder === currentRiddle.levelOrder
				});
				//level w którym podbijamy statystyki
				const levelForRiddle = state.levelList[gameType][levelIndex];
				const points = action.payload.points;

				const levelCollectedPoints = levelForRiddle.collectedPoints + points || points;
				const levelCollectedRiddles = levelForRiddle.collectedRiddles + 1 || 1;

				//łączymy level ze statystkami
				const newLevelObject = Object.assign(
					{},
					{...state.levelList[gameType][levelIndex]},
					{collectedPoints: levelCollectedPoints},
					{collectedRiddles: levelCollectedRiddles}
				);
				// console.log(newLevelObject);

				//zastępujemy level w danym gameType
				const newLevelGameType = state.levelList[gameType].map((level, index) => {
					if (index === levelIndex) return newLevelObject;
					return level
				});

				const newLevelList = Object.assign({}, {...state.levelList}, {[gameType]: newLevelGameType});

				const currentState = Object.assign({}, {...state}, {
					levelList: newLevelList
				});

				// debugger;
				return currentState
			}

			case SAVE_UNLOCKED_RIDDLES: {
				const {unlockedRiddlesList, gameType} = action.payload;
				const {userRiddles} = state;
				// debugger;
				const newRangeRiddlesList = {};
				unlockedRiddlesList.forEach(unlockedRiddlesList => {
					const riddleRange = `${unlockedRiddlesList[0].lp}-${unlockedRiddlesList[unlockedRiddlesList.length - 1].lp}`;

					newRangeRiddlesList[riddleRange] = unlockedRiddlesList;
				})

				const newGameTypeRiddlesList = Object.assign({}, {...userRiddles[gameType]}, newRangeRiddlesList);

				const newRiddlesList = Object.assign({}, {...userRiddles}, {[gameType]: newGameTypeRiddlesList});

				const returnState = Object.assign({}, {...state}, {userRiddles: newRiddlesList});


				return returnState
			}

			case SET_UNLOCK_LIMITS_FOR_EXTRA_LEVELS: {
				const {gameTypesProperties} = action.payload;
				const newUnlockLimitsForExtraLevels = {};
				for (let gameType in gameTypesProperties) {
					if (gameType !== 'classic') {
						if (gameTypesProperties.hasOwnProperty(gameType)) {
							newUnlockLimitsForExtraLevels[gameTypesProperties[gameType].gameType] = gameTypesProperties[gameType].unlockLimit;
						}
					}
				}

				const returnState = Object.assign({}, {...state}, {unlockLimitsForExtraLevels: newUnlockLimitsForExtraLevels});

				return returnState
			}

			case INCREMENT_COLLECTED_RIDDLES: {
				const {gameType} = action.payload;
				const {collectedRiddlesForGameType, collectedRiddlesForAllLevels} = state;
				const currentCollectedRiddleValue = collectedRiddlesForGameType[gameType]
				const newCollectedRiddles = Object.assign({}, {...collectedRiddlesForGameType}, {[gameType]: currentCollectedRiddleValue + 1});

				console.log(`INCREMENT newCollectedRiddles`, newCollectedRiddles);

				return Object.assign({}, {...state},
					{collectedRiddlesForGameType: newCollectedRiddles},
					{collectedRiddlesForAllLevels: collectedRiddlesForAllLevels + 1})
			}

			case DECREMENT_RIDDLE_POINTS_IN_LIST:
				const userRiddles = state.userRiddles;
				const gameType = state.gameType;
				const {currentRiddleRange, activeLogoIndex} = action.payload;

				if (userRiddles[gameType] && userRiddles[gameType][currentRiddleRange]) {
					const newRiddleRangeList = userRiddles[gameType][currentRiddleRange].map((element, index) => {
						if (index === activeLogoIndex) {
							if (element.points && element.points > 0) {
								element.points = element.points - 1;
								console.log("mapa:", element)
							}
						}
						return element;
					});

					const newGameTypeRiddlesList = Object.assign({}, userRiddles[gameType], {[currentRiddleRange]: newRiddleRangeList});
					const newRiddleList = Object.assign({}, userRiddles, {[gameType]: newGameTypeRiddlesList});
					// debugger;
					return Object.assign({}, {...state}, newRiddleList);

				} else {
					return state;
				}
			case SET_IS_DATABASE_RESETTING: {
				return Object.assign({}, {...state}, {isDatabaseResetting: action.payload})
			}
			case SET_CURRENT_EXTRA_LEVEL:
				return Object.assign({}, {...state}, {currentExtraLevel: action.payload.extraLevel});
			case SET_CURRENT_LEVEL:
				return Object.assign({}, {...state}, {currentLevel: action.payload.level});
			case SET_IS_LEVEL_UNLOCKING:
				return Object.assign({}, {...state}, {isUnlocking: action.payload.isUnlocking});
			case TOGGLE_ANSWER_CHECK:
				return Object.assign({}, {...state}, {isCheckingAnswer: action.payload.isChecking});
			case SET_CURRENT_GAME_TYPE:
				return Object.assign({}, {...state}, {gameType: action.payload});
			case RESET_GAME_AFTER_LOGOUT: {
				return Object.assign({}, {...defaultState});
			}
			case RESET_USER_STATE_AFTER_LOGIN: {
				return Object.assign({},
					{...state},
					{userRiddles: defaultState.userRiddles},
					{levelList: defaultState.levelList});
			}
			case SET_IS_DOWNLOADING_RIDDLES: {
				return Object.assign({}, {...state}, {isDownloadingRiddles: action.payload.isDownloadingRiddles});
			}
			case UPDATE_HINT_CLUE_VALUE: {
				const gameType = state.gameType;

				const activeLogoIndex  = action.payload.activeLogoIndex;
				const currentRiddleRange  = action.payload.currentRiddleRange;
				const hintKey  = action.payload.hintKey;
				const hintValue  = action.payload.hintValue;

				const newRiddlesList = state.userRiddles[gameType][currentRiddleRange].map(
					(riddle, index) => {
						if(index === activeLogoIndex){
							return Object.assign({}, riddle, {[hintKey]: hintValue})
						} else {
							return riddle
						}
					}
				);

				console.log(newRiddlesList)

				// const currentGameTypeRiddlesList = {}
				// Object.keys(state.userRiddles[action.payload.gameType]).forEach(riddleRangle => {
				// 	if(riddleRangle == currentRiddleRange){
				// 		currentGameTypeRiddlesList[riddleRangle] = newRiddlesList
				// 	} else {
				// 		currentGameTypeRiddlesList[riddleRangle] = state.userRiddles[action.payload.gameType][riddleRangle]
				// 	}
				// })

				const currentGameTypeRiddlesList = Object.assign({}, {...state.userRiddles[gameType]}, {
						[currentRiddleRange]:
						newRiddlesList
					}
				);

				console.log(currentGameTypeRiddlesList)

				// debugger;
				const currentRiddlesList = Object.assign({}, {...state.userRiddles}, {
					[gameType]: currentGameTypeRiddlesList
				});

				console.log(currentRiddlesList);


				const currentState = Object.assign({}, {...state}, {
					userRiddles: currentRiddlesList
				});
				console.log(currentState);

				return currentState;
			}
			case INITIALIZE_STATS_IN_UNLOCKED_LEVEL:{
				const { gameType, unlockedLevelIndex } = action.payload;
				const gameTypeLevelList = state.levelList[gameType] || [{ levelOrder: unlockedLevelIndex + 1 }];
				console.log(state.levelList)

				if(gameTypeLevelList[unlockedLevelIndex] && gameTypeLevelList[unlockedLevelIndex]["collectedRiddles"]){
					return state
				}

				const unlockedLevel = Object.assign(
					{},
					gameTypeLevelList[unlockedLevelIndex],
					{ collectedRiddles: 0, collectedPoints: 0 });

				const newGameTypeLevelList = [...gameTypeLevelList];

				newGameTypeLevelList[unlockedLevelIndex] = unlockedLevel;

				const newLevelList = Object.assign({}, {...state.levelList}, {[gameType]: newGameTypeLevelList});

				const currentState = Object.assign({}, {...state}, {
					levelList: newLevelList
				});

				return currentState
			}
			default:
				return state;
		}
	} catch(error){
		addReducerParametersToError(error, "error_game_reducer", action, state);
		throw error
	}

}
